import { CompanyDto } from "./company.dto";
import { ExternalJobDto } from "./externalJob.dto";
import { MatchedLeadsProductDto } from "./matchedLeadsProduct.dto";

export class JobBoardProductCreationDto {
    externalJob: ExternalJobDto;
    product: MatchedLeadsProductDto;
    company: CompanyDto;
}